import React from 'react';
import greenBullet from '../assets/images/green-bullet.svg';
import heroImage from '../assets/images/approach/hero.jpg';
import lightIcon from '../assets/images/approach/light.svg';
import monitorIcon from '../assets/images/approach/monitor.svg';
import bookIcon from '../assets/images/approach/book.svg';
import rocketIcon from '../assets/images/approach/rocket.svg';
import heartIcon from '../assets/images/approach/heart.svg';
import cartIcon from '../assets/images/approach/cart.svg';
import laptop1Image from '../assets/images/Laptop1.jpg';
import iPhoneTouchImage from '../assets/images/iPhone_touch.jpg';
import iPhoneImage from '../assets/images/iPhone.jpg';
import laptop2Image from '../assets/images/Laptop2.jpg';
import desktopImage from '../assets/images/Desktop.jpg';
import { Link } from 'react-router-dom';
import './NewApproachPage.css';

const NewApproachPage = () => {
  const innovationEngines = [
    {
      icon: lightIcon,
      title: 'Focus on Asset Quality',
      description: 'We seek to invest in strong, market-leading businesses operating in sectors with attractive fundamental growth, secular tailwinds, resilient demand and low disruption risk.'
    },
    {
      icon: monitorIcon,
      title: 'Identify Tech Upside',
      description: 'Infrastructure. Data analytics. Digital Marketing. Automation. We select opportunities where we see a clear ability to drive growth through the adoption of technology.'
    },
    {
      icon: bookIcon,
      title: 'Augment and Upskill',
      description: 'Our team of operators brings extensive digitally-denominated business transformation capabilities, along with deep sector expertise, to support existing management teams.'
    },
    {
      icon: rocketIcon,
      title: 'Focus on the Future',
      description: 'We prioritize long-term outcomes, instill a culture of modernization and strive to create a continuous improvement loop that accelerates growth and returns.'
    }
  ];

  const targetIndustries = [
    {
      name: 'Healthcare',
      icon: heartIcon
    },
    {
      name: 'Consumer',
      icon: cartIcon
    },
    {
      name: 'Specialty Industrials',
      icon: rocketIcon
    },
    {
      name: 'Business Services',
      icon: bookIcon
    }
  ];

  const whatSetsUsApart = [
    {
      title: 'Digital diagnosis',
      description: 'Our experienced team and extensive suite of resources enable us to identify performance and capability gaps to build an innovation roadmap.'
    },
    {
      title: 'Battle-tested transformation architecture',
      description: 'Our methodology establishes a modern technology foundation which drives value creation across business operations.'
    },
    {
      title: 'Relentless focus on modernization, scalability and repeatability',
      description: 'Consistent impact measurement enables a continuous improvement loop, permitting us to dynamically update our long-term vision and respond to market forces.'
    },
    {
      title: 'Prioritization of long-term potential',
      description: 'Our model allows for more patient ownership when warranted to achieve sustainable growth.'
    }
  ];

  return (
    <div className="new-approach-page">
      {/* Hero Section */}
      <div 
        className="approach-hero" 
        style={{ 
          backgroundImage: `linear-gradient(rgba(13, 21, 38, 0.4), rgba(13, 21, 38, 0.4)), url(${heroImage})` 
        }}
      >
          <p className="approach-hero-subtitle">
            We seek to future-proof businesses
          </p>
      </div>

      {/* Innovation Engines Section */}
      <section className="innovation-engines-section">
          <h2 className="section-title">How We Build Innovation Engines</h2>
          <div className="innovation-engines-grid">
            {innovationEngines.map((engine, index) => (
              <div className="innovation-engine-card" key={index}>
                <div className="innovation-engine-icon">
                  <img src={engine.icon} alt={engine.title} />
                </div>
                <h3 className="innovation-engine-title">{engine.title}</h3>
                <p className="innovation-engine-description">{engine.description}</p>
              </div>
            ))}
          </div>
          <div className="innovation-engines-cta">
            <Link to="/who-we-are" className="learn-more-link">
              LEARN ABOUT BAYPINE
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
              </svg>
            </Link>
          </div>
      </section>

      {/* Quote and Target Industries Section */}
      <section className="quote-section">
          <div className="quote-industries-grid">
            <div className="quote-container">
              <div className="quote-eyebrow"></div>
              <blockquote className="quote-text">
                "We believe the biggest tech trend of our generation isn't about semiconductors or social media – it's about the digitization of the rest of the economy."
              </blockquote>
              <cite className="quote-citation">Anjan Mukherjee, BayPine Managing Partner</cite>
            </div>
            <div className="target-industries-container">
              <h2 className="section-label">
                <img src={greenBullet} alt="" className="bullet-image" />
                OUR TARGET INDUSTRIES
              </h2>
              <div className="target-industries-grid">
                {targetIndustries.map((industry, index) => (
                  <div className="industry-item" key={index}>
                    <div className="industry-icon">
                      <img src={industry.icon} alt={industry.name} />
                    </div>
                    <h3 className="industry-name">{industry.name}</h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
      </section>

      {/* What Sets Us Apart Section */}
      <section className="what-sets-us-apart-section">
          <h2 className="section-title">What sets us apart</h2>
          
          {/* Digital diagnosis with Laptop1.jpg */}
          <div className="what-sets-us-apart-row">
            <div className="what-sets-us-apart-content left">
              <div className="what-sets-us-apart-item">
                <div className="eyebrow-container">
                  <hr className="eyebrow" />
                </div>
                <h3 className="what-sets-us-apart-title">{whatSetsUsApart[0].title}</h3>
                <p className="what-sets-us-apart-description">{whatSetsUsApart[0].description}</p>
              </div>
            </div>
            <div className="what-sets-us-apart-image right">
              <img src={laptop1Image} alt="Digital diagnosis" />
            </div>
          </div>
          
          {/* Battle-tested transformation architecture with iPhone_touch.jpg */}
          <div className="what-sets-us-apart-row">
            <div className="what-sets-us-apart-image left">
              <img src={iPhoneTouchImage} alt="Battle-tested transformation architecture" />
            </div>
            <div className="what-sets-us-apart-content right">
              <div className="what-sets-us-apart-item">
                <div className="eyebrow-container">
                  <hr className="eyebrow" />
                </div>
                <h3 className="what-sets-us-apart-title">{whatSetsUsApart[1].title}</h3>
                <p className="what-sets-us-apart-description">{whatSetsUsApart[1].description}</p>
              </div>
            </div>
          </div>
          
          {/* Relentless focus on modernization with iPhone.jpg */}
          <div className="what-sets-us-apart-row">
            <div className="what-sets-us-apart-content left">
              <div className="what-sets-us-apart-item">
                <div className="eyebrow-container">
                  <hr className="eyebrow" />
                </div>
                <h3 className="what-sets-us-apart-title">{whatSetsUsApart[2].title}</h3>
                <p className="what-sets-us-apart-description">{whatSetsUsApart[2].description}</p>
              </div>
            </div>
            <div className="what-sets-us-apart-image right">
              <img src={iPhoneImage} alt="Relentless focus on modernization" />
            </div>
          </div>
          
          {/* Prioritization of long-term potential with Laptop2.jpg */}
          <div className="what-sets-us-apart-row">
            <div className="what-sets-us-apart-image left">
              <img src={laptop2Image} alt="Prioritization of long-term potential" />
            </div>
            <div className="what-sets-us-apart-content right">
              <div className="what-sets-us-apart-item">
                <div className="eyebrow-container">
                  <hr className="eyebrow" />
                </div>
                <h3 className="what-sets-us-apart-title">{whatSetsUsApart[3].title}</h3>
                <p className="what-sets-us-apart-description">{whatSetsUsApart[3].description}</p>
              </div>
            </div>
          </div>
          
          {/* Final Desktop.jpg image */}
          <div className="what-sets-us-apart-final-image">
            <img src={desktopImage} alt="Desktop" />
          </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
          <div className="contact-grid">
            <div className="contact-item talk-with-us">
              <h3 className="contact-title">
                <img src={greenBullet} alt="" className="bullet-image" />
                TALK WITH US
              </h3>
              <p className="contact-description">
                We're always eager to make new connections and provide more information.
              </p>
              <Link to="/contact" className="contact-link">
                GET IN TOUCH
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
                </svg>
              </Link>
            </div>
            <div className="contact-item join-us">
              <h3 className="contact-title">
                <img src={greenBullet} alt="" className="bullet-image" />
                JOIN US
              </h3>
              <p className="contact-description">
                Join our dynamic and ambitious team.
              </p>
              <a href="mailto:Careers@BayPine.com" className="contact-link">
                INQUIRE ABOUT AVAILABLE OPPORTUNITIES
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>
      </section>
    </div>
  );
};

export default NewApproachPage;
